/** ຂໍ້ຄວາມສະແດງຈາກ ລະຫັດ/ຊື່ເກຣດມອບໝາຍ — ບໍ່ມີເກຣດໃດໆ = ລະບົບເລືອກໃຫ້ */
export function formatSalaryGradeCodeLabelDisplay(
  code: string | null | undefined,
  label: string | null | undefined,
): string {
  const c = code?.trim() ?? "";
  const l = label?.trim() ?? "";
  if (c !== "") {
    return l !== "" && l !== c ? `${c} — ${l}` : c;
  }
  return "ລະບົບເລືອກໃຫ້";
}
